// extracted by mini-css-extract-plugin
export var errorIcon = "_k4-1";
export var nameLogo = "_k4-0";